export default {"src":"/_next/static/media/Ronin.b37d6bd9.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};